import React from 'react';

const ResetPasswordModal = ({
  show,
  username,
  loading,
  onUsernameChange,
  onClose,
  onSubmit,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(15, 23, 42, 0.55)' }}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '1rem' }}>
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">Reset Password</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Tutup" />
          </div>
          <div className="modal-body pt-2">
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control form-control-lg"
              value={username}
              onChange={(e) => onUsernameChange(e.target.value)}
              autoFocus
            />
            <p className="text-muted small mt-2 mb-0">
              Password akan direset ke <strong>Qwerty123#</strong>
            </p>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-light" onClick={onClose}>
              Batal
            </button>
            <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={loading}>
              {loading ? 'Memproses…' : 'Reset Password'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
